<template>
  <v-container>
    <app-activity-indicator v-if="loading"></app-activity-indicator>
    <v-row  v-else class="pr-5">
        <v-row v-if="!product.unlocked">
          <v-col cols="12" md="4">
            <v-card elevation=0>
                <v-img
                class="white--text"
                height="150px"
                contain
                src="/images/products/tools-tile1.jpg"
                >
                </v-img>
                <v-card-title class="justify-center">
                <div>
                  <h3 class="headline text-md-center teal--text mb-0">{{product.cost}}</h3>
                </div>
                </v-card-title>
                <v-card-actions class="justify-center">
                <v-btn color="teal" dark @click="showAlert">Buy</v-btn>
                </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" md="8">
              <h1 class="headline">Binding Child Support Agreement</h1>
              <p>Children are expensive. Their needs are ever growing and ever demanding. Before you get to the point of angst or frustration, the Binding Child Support Agreement is like a costs agreement on items beyond minimum Child Support.</p>
              <p>Don't let the financials become an ongoing source of bitterness between you and your ex-partner. Get clarity to the financial child maintenance responsibilities and liabilities for each parent with your Binding Child Support Agreement now!</p>
          </v-col>
        </v-row>
        <div v-else class="main-layout">
          <v-navigation-drawer v-model="helpDrawer" fixed right app>
            <v-app-bar>
              <v-toolbar-title>Help</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn text icon @click="helpDrawer = !helpDrawer">
                <v-icon>close</v-icon>
              </v-btn>
            </v-app-bar>
            <v-expansion-panels :value="0">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="subheading">Disclaimer</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <span class="body-2">This Binding Child Support Agreement is presented as general advice only and is not provided as legal advice. Divorce Answered has gone to great lengths to provide a detailed and fair Binding Child Support Agreement for subscribed use however cannot be held liable for any misuse of this Binding Child Support Agreement or for any final court orders arising from the use of this Binding Child Support Agreement. It is intended to be used as a guide prior to consultation with a solicitor or other legal professionals familiar with your specific legal requirements and circumstances. It is not to be used as a substitute for legal advice from a registered legal professional. Please consult your legal professional to ensure that the documentation meets all legal requirements for your state, territory and jurisdiction</span>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="subheading">Explanation</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <span class="body-2">A binding financial agreement is a mutual agreement between a child[ren]’s biological, adopted and/or eligible non-parent carer. It cannot be altered, replaced or terminated (section 80CA) unless replaced by a Court Ordered Binding Child Support Agreement or by Order of the Court (in the case of termination). It is essential that you read and follow the directions of use as outlined below, otherwise the Agreement will be void.</span>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="subheading">Direction Of Use</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="body-2">One: make the mutual child support agreement with the child(ren)’s biological, adopted and/or eligible non-parent carer.</p>
                  <p class="body-2">Two: before signing, have the form reviewed and explained by independent lawyers/solicitors about the benefits and shortcomings of the agreement.</p>
                  <p class="body-2">Three: each parent can sign the agreement.</p>
                  <p class="body-2">Four: each legal professional signs a legal certificate as declaration of the advice provided to the respective undersigned prior to the agreement being signed. It is essential that each undersigned has different legal practitioner, otherwise the agreement will be void in accordance with section 80C(2) of the Act.</p>
                  <p class="body-2">Five: Lodge the agreement and legal certificates as annexure at the court to be made an Order.</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="subheading">Terminology</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="body-2">a. "Act" refers to the Child Support (Assessment) Act of 1989 and extends to all statutes amending, consolidating or replacing the same</p>
                  <p class="body-2">b. "Agency" refers to the Child Support Agency</p>
                  <p class="body-2">c. "Assessment" refers to any administrative assessment or amended administrative assessment for a parent to pay child support, made or to be made by the Agency pursuant to the Act</p>
                  <p class="body-2">d. "Eligible carer" refers to the person with at least shared care of a child or children and otherwise defined by section 7B of the Act</p>
                  <p class="body-2">e. "Liable parent" refers to the parent whose responsibility it is to pay child support and otherwise as defined by this agreement</p>
                  <p class="body-2">f. "Parties" refers to Parent A and Parent B</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-navigation-drawer>
          <v-app-bar fixed class="toolbar">
            <v-toolbar-title>Binding Child Support Agreement</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="teal"  class="mr-4" dark :loading="isSaving" @click="save">
              Save
            </v-btn>
            <v-btn color="teal" outlined :loading="isExportingPdf" @click="exportPDF">
              Download PDF
            </v-btn>
            <v-btn text icon color="teal" @click="helpDrawer = !helpDrawer">
              <v-icon>help_outline</v-icon>
            </v-btn>
          </v-app-bar>
          <v-row>
            <v-col cols="12">
              This agreement is made on
                <v-menu
                  v-model="product.menuDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  class="inline ml-2"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="inline ml-2"
                    readonly
                    label="Date"
                    v-on="on"
                    :value="product.data.date | formatDatePicker"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="product.data.date"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
                </v-menu>
                , between
                <v-text-field v-model="product.data.parentAName"
                  class="inline ml-2"
                  label="Parent Name"
                ></v-text-field>
                , of
                <v-text-field v-model="product.data.parentAAddress"
                  class="inline ml-2"
                  label="Address"
                ></v-text-field>
                  (herein “Parent A”) and
                  <v-text-field v-model="product.data.parentBName"
                  class="inline ml-2"
                  label="Parent Name"
                ></v-text-field>
                , of
                <v-text-field v-model="product.data.parentBAddress"
                  class="inline ml-2"
                  label="Address"
                ></v-text-field>
                (herein “Parent B”)
            </v-col>
            <v-col cols="12">
              In regards to this agreement "child(ren)"" refers to:
            </v-col>
            <v-col cols="12">
              <ol type="a">
                <li v-for="(child, index) in product.data.children" :key="index">
                  Child:
                  <v-text-field v-model="child.name"
                  class="inline ml-2"
                  label="Child's full name"
                ></v-text-field>
                born on
                <v-menu
                  v-model="child.menuDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  class="inline ml-2"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="inline ml-2"
                    readonly
                    label="Date"
                    v-on="on"
                    :value="child.dob | formatDatePicker"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="child.dob"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
                </v-menu>
                (herein <v-text-field v-model="child.firstName"
                  class="inline ml-2"
                  label="Child's first name"
                ></v-text-field>)
                <v-btn text icon color="error" @click="product.data.children.splice(index, 1)">
                  <v-icon>clear</v-icon>
                </v-btn>
                </li>
              </ol>
              <v-btn dark color="teal" @click="product.data.children.push({})">Add Child +</v-btn>
            </v-col>
            <hr class="ma-2"/>
            <v-col cols="12">
              <ol>
                <li>This is a Binding Child Support Agreement under section 80C and section 81 of the Act.</li>
                <li>The child(ren) are:</li>
                <ol type="a">
                  <li>Under 18 years</li>
                  <li>Neither are married or living in a registered, legitimate de facto relationship</li>
                  <li>Present in Australia at the date of the Agreement</li>
                  <li>Australian Citizens</li>
                  <li>Reside in Australia at the date of the Agreement</li>
                </ol>
                <li>The Parties are legal parents of the children</li>
                <li>The Parties
                  <v-select
                    :items="['married', 'commenced living together']"
                    v-model="product.data.relationshipType"
                    label="Select relationship"
                    class="inline ml-2"
                    style="max-width: 250px"
                  ></v-select>
                  on
                  <v-menu
                  v-model="product.data.menuMarriedDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="250px"
                  class="inline-date ml-2"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="inline-date ml-2"
                    readonly
                    label="Date"
                    v-on="on"
                    :value="product.data.marriedDate | formatDatePicker"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="product.data.marriedDate"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
                </v-menu>
                  and separated on
                  <v-menu
                  v-model="product.data.menuSeparationDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="250px"
                  class="inline-date ml-2"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="inline-date ml-2"
                    readonly
                    label="Date"
                    v-on="on"
                    :value="product.data.separationDate | formatDatePicker"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="product.data.separationDate"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
                </v-menu>
                </li>
                <li>The Child(ren) live with
                  <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.childrenLivingWith"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                  and spend time with
                  <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.childrenSpendTimeWith"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                  on occasion of
                  <v-text-field v-model="product.data.childrenSpendTimeAgreement"
                    label="Describe Agreement"
                  ></v-text-field>
                  </li>
                  <li>
                    <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.eligibleCarer"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                    is considered the eligible carer entitled to Child Support under the provisions of the Act in relation to the children and is the person to whom Child Support is to be paid or provided under the agreement.
                  </li>
                  <li>
                    <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.liableParent"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                    is the liable parent and is the party responsible for providing the child support for the purposes of section 84 of the Act.
                  </li>
                  <li>
                    <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.parentTaxBenefit"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                    [as noted in clause 6]
                    <v-select
                    :items="['is', 'is not']"
                    v-model="product.data.parentTaxBenefitStatus"
                    label="Is/Is not"
                    class="inline ml-2"
                    style="max-width: 80px"
                  ></v-select>
                    in receipt of the Family Tax Benefit A
                  </li>
                  <li>
                    <v-select
                    :items="['Parent A', 'Parent B']"
                    v-model="product.data.parentReceivingPension"
                    label="Parent"
                    class="inline ml-2"
                    style="max-width: 100px"
                  ></v-select>
                    [as noted in clause 6 and 8]
                    <v-select
                    :items="['is', 'is not']"
                    v-model="product.data.parentReceivingPensionStatus"
                    label="Is/Is not"
                    class="inline ml-2"
                    style="max-width: 80px"
                  ></v-select>
                    receiving an income-tested pension.
                  </li>
                  <li>The terms of the Agreement commence from the date of the Agreement</li>
                  <li>This Agreement is binding on and enforceable by the personal representatives, legal representatives, trustees, executors and administrators of Parent A or their estate</li>
                  <li>This Agreement is binding on and enforceable by the personal representatives, legal representatives, trustees, executors and administrators of Parent B or their estate</li>
                  <li>The Agreement is for the Liable Parent to pay child support amount of/in</li>
                  <ol type="a">
                    <v-radio-group v-model="product.data.childSupportAmountOption">
                      <li><v-radio class="inline" value="0"></v-radio>$
                        <v-text-field class="inline" v-model="product.data.childSupportAmount" label="Amount" style="max-width: 100px"></v-text-field>/annum net per fiscal year (or pro-rata)</li>
                      <li><v-radio class="inline" value="1"></v-radio>monthly instalments payable on the first day of every month ($
                        <v-text-field class="inline" v-model="product.data.childSupportMonthlyInstalments" label="Amount" style="max-width: 100px"></v-text-field>
                        /month)</li>
                      <li><v-radio class="inline" value="2"></v-radio>quarterly instalments payable on the first day of each fiscal quarter ($
                        <v-text-field class="inline" v-model="product.data.childSupportQuarterlyInstalments" label="Amount" style="max-width: 100px"></v-text-field>
                      )</li>
                    </v-radio-group>
                    </ol>
                  <li>In addition to Child Support as outlined in clause 13, further costs for the child(ren) are liable and payable as follows</li>
                  <ol type="a">
                    <li>For education costs, Parent A is responsible for <v-text-field class="inline" v-model="product.data.educationCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.educationCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For health insurance, Parent A is responsible for <v-text-field class="inline" v-model="product.data.healthInsuranceCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.healthInsuranceCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For medical care expenses, Parent A is responsible for <v-text-field class="inline" v-model="product.data.medicalCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.medicalCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For dental expenses, Parent A is responsible for <v-text-field class="inline" v-model="product.data.dentalCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.dentalCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For vision expenses, Parent A is responsible for <v-text-field class="inline" v-model="product.data.visionCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.visionCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For mental health expenses, Parent A is responsible for <v-text-field class="inline" v-model="product.data.mentalHealthCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.mentalHealthCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For tertiary or further education expenses, Parent A is responsible for <v-text-field class="inline" v-model="product.data.tertiaryEducationCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.tertiaryEducationCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                    <li>For extra-curricular activities or outside of standard schooling activities, Parent A is responsible for <v-text-field class="inline" v-model="product.data.activitiesCostParentA" label="Amount" style="max-width: 100px"></v-text-field> percent and Parent B to be responsible for <v-text-field class="inline" v-model="product.data.activitiesCostParentB" label="Amount" style="max-width: 100px"></v-text-field> percent</li>
                  </ol>
                  <li>As each Child Support payment (annual, quarterly or monthly, as agreed) in this agreement as set out in clause 13 is received, the amount is to be credited against the amount payable under the administrative assessment</li>
                  <li>The parties agree that the annual Child Support payable as outlined in clause 13 will be equal or be greater than the administrative assessment</li>
                  <li>Child Support payable only provides for monetary payment (cash, not goods, services, shares, other payments or benefits and arrangements)</li>
                  <li>The eligible carer is entitled to take court action against the payer to enforce the amounts payable under the child support agreement (section 95(3)(b))</li>
                  <li>The Liable Parent may make payments to the other parent’s bank account or third party acting as the agent of the payee, such as a solicitor, trustee or Child Support Australia, as directed by the other parent.</li>
                  <li>The Agreement terminates or ceases to operate in relation to a child (except for any arrears due on the date that the Agreement ceases to operate) on December 31 at 23:59 the year the youngest child completes Year 12, or should the child not complete secondary schooling, the year the youngest child turns 18 years.</li>
                  <li>This Agreement may be extended in <v-text-field class="inline" v-model="product.data.extensionYear" label="Enter Year" style="max-width: 100px"></v-text-field> [same as clause 20] to include Child Support for tertiary or further education for the child[ren] until December 31 at 23:59 the year the youngest child completes the tertiary/further education.</li>
                  <li>Under the Family Law Act, Child Support Orders will terminate (unless stated otherwise)</li>
                  <ol type="a">
                    <li>If the child dies</li>
                    <li>If the paying parent dies, unless the order expressly provides for it to continue after their death</li>
                    <li>If the receiving parent dies, unless expressly provides for it to continue after their death and another person is nominated to receive payments</li>
                    <li>If the child is adopted, marries or starts a de facto relationship</li>
                    <li>When the child turns 18 unless stated to continue after that date</li>
                    <li>When the child finishes school, unless the order was made to enable the child to complete further/tertiary education</li>
                    <li>If the child no longer has a disability where the order is for a child aged over 18 years and was made because the child has a physical or mental disability.</li>
                  </ol>
                  <li v-for="(clause, index) in product.data.extraClauses" :key="index">
                    <v-row>
                      <v-col cols="10">
                        <v-text-field v-model="clause.description" label="Clause Description"></v-text-field>
                      </v-col>
                      <v-col cols="2">
                        <v-btn text icon color="error" @click="product.data.extraClauses.splice(index, 1)">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </li>
                  <v-btn dark color="teal" @click="product.data.extraClauses.push({})">Add Clause +</v-btn>
              </ol>
            </v-col>
          </v-row>
        </div>
    </v-row>
    <product-purchase-dialog
      :dialogVisible="dialogVisible"
      :test="product.test"
      :firstName="firstName"
      :lastName="lastName"
      :email="email"
      :productName="product.name"
      :amount="product.cost"
      :stripePriceId="product.stripePriceId"
      @input="didDismissDialog"
      :didCompletePurchase="didCompletePurchase"></product-purchase-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    productId: 'f6670f3c-01a8-4e7e-8edc-bb2a1e91f4ed',
    activeTab: 0,
    dialogVisible: false,
    helpDrawer: true
  }),
  created () {
    this.$store.dispatch('products/view', this.productId)
  },
  computed: {
    product () {
      return this.$store.getters['products/loadedProduct']
    },
    loading () {
      return this.$store.getters.loading
    },
    isSaving () {
      return this.$store.getters['products/isSaving']
    },
    isExportingPdf () {
      return this.$store.getters['products/isExportingPdf']
    },
    firstName () {
      return this.$store.getters.user.firstName
    },
    lastName () {
      return this.$store.getters.user.lastName
    },
    email () {
      return this.$store.getters.user.email
    }
  },
  watch: {
    // menu (val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    // }
  },
  methods: {
    save () {
      this.$store.dispatch('products/save')
    },
    showAlert () {
      this.dialogVisible = true
    },
    didDismissDialog (value) {
      this.dialogVisible = false
    },
    didCompletePurchase (productId) {
      this.$store.dispatch('products/unlock', this.productId)
    },
    exportPDF () {
      this.$store.dispatch('products/exportPDF')
    }
  }
}
</script>

<style scoped>
.main-layout {
  margin-top: 64px;
}
.index-card {
  position: fixed;
  right: 0;
  top: 140px;
  right: 24px;
  z-index: 1;
}
</style>
